import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { TextBox } from 'fw/forms';
import { SetupSearch } from 'areas/shared/pages/setup';

class Search extends SetupSearch {

    initialForm() {
        return {
            code: "",
            description: ""
        };
    }

    ready = () => {
        this.focusControl && this.focusControl.focus();
    }

    renderForm() {
        return (
            <Row>
                <Col md={4}>
                    <TextBox
                        name="code"
                        placeholder="Code"
                        ref={(c) => { this.focusControl = c }} />
                </Col>
                <Col md={4}>
                    <TextBox
                        name="description"
                        placeholder="Description" />
                </Col>
            </Row>
        )
    }
}

export default Search;



// WEBPACK FOOTER //
// ./src/areas/admin/denialCodeSetup/Search.js